export const ROUTE_PATH = '/invites';
